// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export { list, get } from "./operations.js";
export {
  PrivateLinkResourcesListOptionalParams,
  PrivateLinkResourcesGetOptionalParams,
} from "./options.js";
